import { API, Endpoints, Tag } from "@brg/api";
import { bTag } from "core";
import { BTag } from "core/components";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { LimitedLink } from "shared/pages/project/project";
import { ShowMoreWrapper, SyntheticContainer, Text } from "./styles";
import { FlexBox, useIsMobile } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { LoaderIcon } from "shared/modals/artzLegalsModal/LoaderAnimation";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { AppTester } from "supporting";

const SyntheticShowMore: FC<{ onClick?: () => void, open?: boolean }> = ({ onClick, open }) => {
    const { t } = useTranslation();

    return (
        <SyntheticContainer>
            <span onClick={onClick}>{open ? t('show_less_text'): t('show_more_text')}</span>
        </SyntheticContainer>
    )

}


export const ShowMoreWithTags: FC<{text: string, showTags?: boolean, tagsIds?: string[] }> = ({ tagsIds = [], text, showTags }) => {
    const isMobile = useIsMobile();
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const currentLangRef = useRef<string | null>(null)
    const [tags, setTags] = useState<Tag[]>();
    const [isTagsLoading, setIsTagsLoading] = useState(false);
    const divRef = useRef<HTMLDivElement>(null)
    const [open, setOpen] = useState(false);
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const [showMoreVisible, setShowMoreVisible] = useState(false)


    async function getTags() {
        if (!tags?.length) {
            setIsTagsLoading(true)
        }
        return await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/tags/GetTags')
            .addQuery('tagIds', tagsIds)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsTagsLoading(false)
                setTags(API.toLang(r, language))
            })
    }

    const onShowMoreClick = (e?: any) => {
        e?.preventDefault();
        e?.stopPropagation();

        if (tagsIds?.length) {
            getTags();
        }

        setOpen(!open)
    }

    const checkShowMoreVisibility = () => {
        if (divRef.current) {
            const element = divRef.current;
            const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10) || 20
            const maxHeight = lineHeight * 2; // 2 строки
            setShowMoreVisible(element.scrollHeight > maxHeight)
        }
    };

    useEffect(() => {
        checkShowMoreVisibility();
        const observer = new ResizeObserver(checkShowMoreVisibility)
        
        if (divRef.current) {
            observer.observe(divRef.current)
        }

        return () => observer.disconnect()
    }, [text])

    useEffect(() => {
        if (currentLangRef.current !== language) {
            setOpen(false);
            setTags([]);
        }
        currentLangRef.current = language
    } , [language])

    const tagsContent = useMemo(() => {
        if(!showTags || !open) return null
        
        return isTagsLoading ? (
                <FlexBox 
                    style={{ height: '50px' ,width: '100%' }} 
                    justify="center" 
                    align="center"
                >
                    <LoaderIcon />
                </FlexBox>
            ) : !!tags?.length ? (
                <BTagsGridNew style={{ margin: '8px 0 0 0', width: '100%', maxHeight: isAdcrDafesNet ? '100%' : '' }}>
                    {tags?.map((tag) => (
                        <LimitedLink key={tag.tagId} to={CreateLinkTo.tag(tag?.tagId)} target={'_BLANK'}>
                            <BTag tag={tag} educational={tag.isEducationTag} organization={tag.isTeamTag} isProjectsTag isShowMoreTag>
                                {bTag.title(tag)}
                                <ReactTooltip {...getTooltipStyles(theme as any)} />
                            </BTag>
                        </LimitedLink>
                    ))}
                </BTagsGridNew>
            ) : 
            null
    }, [showTags, open, isTagsLoading, tags, isAdcrDafesNet, theme]);

    if ((!text?.length || text === 'null') && !tagsIds?.length) {
        return null;
    }

    return (
        <ShowMoreWrapper open={open}>
            <Text 
                ref={divRef}
                fontSize={isMobile ? "11" :'15'} 
                color={theme.competition.juryDesc}
                pt={isMobile ? "4" : "8"} 
                fw={"400"}
                lh={'16'}
                isShowcase
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: open ? 'unset' : 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                {text === "null" ? '' : text}
            </Text>
            {tagsContent}
            {showMoreVisible && (
                <SyntheticShowMore 
                    onClick={onShowMoreClick} 
                    open={open} 
                />
            )}
        </ShowMoreWrapper>
    )
}import { API, Endpoints, Tag } from "@brg/api";
import { bTag } from "core";
import { BTag } from "core/components";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { CreateLinkTo } from "shared/constants/linkTo";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { LimitedLink } from "shared/pages/project/project";
import { ShowMoreWrapper, SyntheticContainer, Text } from "./styles";
import { FlexBox, useIsMobile } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { LoaderIcon } from "shared/modals/artzLegalsModal/LoaderAnimation";
import ReactTooltip from "react-tooltip";
import { getTooltipStyles } from "shared/constants/tooptipStyles";
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { AppTester } from "supporting";

const SyntheticShowMore: FC<{ onClick?: () => void, open?: boolean }> = ({ onClick, open }) => {
    const { t } = useTranslation();

    return (
        <SyntheticContainer>
            <span onClick={onClick}>{open ? t('show_less_text'): t('show_more_text')}</span>
        </SyntheticContainer>
    )

}


export const ShowMoreWithTags: FC<{text: string, showTags?: boolean, tagsIds?: string[] }> = ({ tagsIds = [], text, showTags }) => {
    const isMobile = useIsMobile();
    const { t, i18n: { language } } = useTranslation();
    const theme = useTheme();
    const currentLangRef = useRef<string | null>(null)
    const [tags, setTags] = useState<Tag[]>();
    const [isTagsLoading, setIsTagsLoading] = useState(false);
    const divRef = useRef<HTMLDivElement>(null)
    const [open, setOpen] = useState(false);
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const [showMoreVisible, setShowMoreVisible] = useState(false)


    async function getTags() {
        if (!tags?.length) {
            setIsTagsLoading(true)
        }
        return await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/tags/GetTags')
            .addQuery('tagIds', tagsIds)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsTagsLoading(false)
                setTags(API.toLang(r, language))
            })
    }

    const onShowMoreClick = (e?: any) => {
        e?.preventDefault();
        e?.stopPropagation();

        if (tagsIds?.length) {
            getTags();
        }

        setOpen(!open)
    }

    const checkShowMoreVisibility = () => {
        if (divRef.current) {
            const element = divRef.current;
            const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10) || 20
            const maxHeight = lineHeight * 2; // 2 строки
            setShowMoreVisible(element.scrollHeight > maxHeight)
        }
    };

    useEffect(() => {
        checkShowMoreVisibility();
        const observer = new ResizeObserver(checkShowMoreVisibility)
        
        if (divRef.current) {
            observer.observe(divRef.current)
        }

        return () => observer.disconnect()
    }, [text])

    useEffect(() => {
        if (currentLangRef.current !== language) {
            setOpen(false);
            setTags([]);
        }
        currentLangRef.current = language
    } , [language])

    const tagsContent = useMemo(() => {
        if(!showTags || !open) return null
        
        return isTagsLoading ? (
                <FlexBox 
                    style={{ height: '50px' ,width: '100%' }} 
                    justify="center" 
                    align="center"
                >
                    <LoaderIcon />
                </FlexBox>
            ) : !!tags?.length ? (
                <BTagsGridNew style={{ margin: '8px 0 0 0', width: '100%', maxHeight: isAdcrDafesNet ? '100%' : '' }}>
                    {tags?.map((tag) => (
                        <LimitedLink key={tag.tagId} to={CreateLinkTo.tag(tag?.tagId)} target={'_BLANK'}>
                            <BTag tag={tag} educational={tag.isEducationTag} organization={tag.isTeamTag} isProjectsTag isShowMoreTag>
                                {bTag.title(tag)}
                                <ReactTooltip {...getTooltipStyles(theme as any)} />
                            </BTag>
                        </LimitedLink>
                    ))}
                </BTagsGridNew>
            ) : 
            null
    }, [showTags, open, isTagsLoading, tags, isAdcrDafesNet, theme]);

    if ((!text?.length || text === 'null') && !tagsIds?.length) {
        return null;
    }

    return (
        <ShowMoreWrapper open={open}>
            <Text 
                ref={divRef}
                fontSize={isMobile ? "11" :'15'} 
                color={theme.competition.juryDesc}
                pt={isMobile ? "4" : "8"} 
                fw={"400"}
                lh={'16'}
                isShowcase
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: open ? 'unset' : 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                {text === "null" ? '' : text}
            </Text>
            {tagsContent}
            {showMoreVisible && (
                <SyntheticShowMore 
                    onClick={onShowMoreClick} 
                    open={open} 
                />
            )}
        </ShowMoreWrapper>
    )
}